import { render, staticRenderFns } from "./RiskScoreLegend.vue?vue&type=template&id=601e4587&scoped=true"
import script from "./RiskScoreLegend.vue?vue&type=script&lang=js"
export * from "./RiskScoreLegend.vue?vue&type=script&lang=js"
import style0 from "./RiskScoreLegend.vue?vue&type=style&index=0&id=601e4587&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601e4587",
  null
  
)

export default component.exports